import { useEffect } from "react"
import useUserById from "~hooks/useUserById"
import UserShippingAddress from "~components/users/UserShippingAddress"

interface Props {
  userId: string
}

const ShippingRedemption = ({ userId }: Props) => {
  const {
    data: user,
    isFetching: isFetchingUser,
    refetch: fetchUser,
  } = useUserById(userId)

  useEffect(() => {
    ;(async () => {
      await fetchUser()
    })()
  }, [])

  return (
    <>
      {isFetchingUser ? (
        <span>Loading...</span>
      ) : (
        <UserShippingAddress user={user} />
      )}
    </>
  )
}

export default ShippingRedemption
